import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Mail, Linkedin, Instagram, Copy, Check } from 'lucide-react';
import './Footer.css';

const Footer = () => {
  const [copied, setCopied] = useState(false);
  const email = "Megha.1581@gmail.com";

  const handleEmailClick = async () => {
    try {
      await navigator.clipboard.writeText(email);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      // Fallback for older browsers
      const textArea = document.createElement('textarea');
      textArea.value = email;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-links">
            <button 
              onClick={handleEmailClick}
              className="footer-link footer-email-btn"
              aria-label="Copy email"
              title="Click to copy email"
            >
              {copied ? <Check size={20} /> : <Mail size={20} />}
              <span>{copied ? "Copied!" : "Email"}</span>
            </button>
            <a 
              href="https://www.linkedin.com/in/megha-mehta-203b46117/" 
              target="_blank"
              rel="noopener noreferrer"
              className="footer-link"
              aria-label="LinkedIn"
            >
              <Linkedin size={20} />
              <span>LinkedIn</span>
            </a>
            <a 
              href="https://www.instagram.com/meghadevani?igsh=MXRvbzJxbjR1OXNvZA%3D%3D&utm_source=qr" 
              target="_blank"
              rel="noopener noreferrer"
              className="footer-link"
              aria-label="Instagram"
            >
              <Instagram size={20} />
              <span>Instagram</span>
            </a>
          </div>
          
          <div className="footer-copyright">
            <p>© {new Date().getFullYear()} Megha Mehta</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
